/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
  useTheme
} from '@mui/material';
import moment from 'moment';
import PhoneIcon from '@mui/icons-material/Phone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import SmsIcon from '@mui/icons-material/Sms';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PencilAltIcon from '../../../icons/PencilAlt';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import useAuth from '../../../hooks/useAuth';
import { useEffect, useState, useRef } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { customerApi } from '../../../api/customerApi';
import toast from 'react-hot-toast';
import { alpha } from '@mui/material/styles';
import { getTone, greyAlpha, grey } from '../../../theme/tones';
import usePermissions from '../../../hooks/usePermissions';

const RelaunchCustomerRelaunchComment = (props) => {
  const { comment_relance, customer, formations, customerId, campaignId, setIsTreated, saveTime, commentRelance, setCommentRelance, ...other } = props;
  const { user } = useAuth();
  const { can } = usePermissions();
  const theme = useTheme();
  const [commenting, setCommenting] = useState(false);

  useEffect(() => {
    setCommentRelance(comment_relance);
  }, [comment_relance, setCommentRelance]);

  useEffect(() => {
    if (commentRelance !== null && commentRelance !== undefined) {
      if (Object.keys(commentRelance).length !== 0 && commentRelance.constructor === Object) {
        setCommentRelance(commentRelance);
      }
    }
  }, [commentRelance, setCommentRelance]);

  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };

  const qualificationLabel = [
    'Pas répondu', 'À rappeler', 'Numéro incorrect', 'Va se connecter', 'Suivi - Téléphone', 'Suivi - Mail', 'Suivi - SMS', 'Décalage', 'Annulation'
  ];

  const [choiceRelance, setChoiceRelance] = useState(null);
  const [choiceQualificationRecall, setChoiceQualificationRecall] = useState(null);
  const [displayDateRecall, setDisplayDateRecall] = useState(false);

  const handleChangeQualification = (value) => {
    setChoiceRelance(value);
    switch (value) {
      case 'À rappeler':
        setDisplayDateRecall(true);
        break;
      default:
        setDisplayDateRecall(false);
        break;
    }
  };

  const [isFormFilled, setIsFormFilled] = useState(true);

  useEffect(() => {
    if (choiceRelance !== null && choiceRelance !== 'À rappeler') {
      setIsFormFilled(false);
    } else {
      setIsFormFilled(true);
    }
    if (choiceRelance !== null && choiceRelance === 'À rappeler' && choiceQualificationRecall !== null && choiceQualificationRecall !== '') {
      setIsFormFilled(false);
    }
  }, [choiceRelance, choiceQualificationRecall]);

  const formikRef = useRef();
  useEffect(() => {
    setChoiceQualificationRecall(null);
    if (formikRef.current) {
      formikRef.current.values.choiceQualificationRecall = null;
    }
  }, [choiceRelance]);

  // Color mapping based on qualification
  const getQualificationColor = (qualif) => {
    switch (qualif) {
      case 'Suivi - Mail':
      case 'Suivi - SMS':
      case 'Suivi - Téléphone':
        return getTone('emerald').base; // Green
      case 'Annulation':
        return getTone('rose').base; // Red
      case 'Décalage':
      case 'Pas répondu':
        return getTone('neutral').base; // Gray/Slate
      case 'À rappeler':
        return getTone('orange').base; // Orange
      case 'Souhaite un email':
        return getTone('violet').base; // Purple
      case 'Va se connecter':
        return getTone('amber').base; // Yellow
      case 'Numéro incorrect':
        return getTone('blue').base; // Blue
      default:
        return getTone('neutral').base;
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {commenting && (
        <Card
          sx={{
            borderRadius: '24px',
            border: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'background.paper',
            backdropFilter: 'blur(20px)',
            boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
            overflow: 'hidden'
          }}
        >
          <Formik
            innerRef={formikRef}
            initialValues={{
              commentRelance: '',
              choiceRelance: null,
              choiceQualificationRecall: ''
            }}
            enableReinitialize
            validationSchema={Yup.object().shape({
              commentRelance: Yup.string().nullable(),
              choiceRelance: Yup.string().nullable(),
              choiceQualificationRecall: Yup.string().nullable()
            })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
              try {
                const jsonAnswer = await customerApi.addCommentRelance(customerId, user.id, values, localStorage.getItem('accessToken'));
                setStatus({ success: true });
                resetForm({});
                setSubmitting(false);
                toast.success('Commentaire de la relance enregistré !');
                setCommenting(false);
                setCommentRelance({
                  id: jsonAnswer.data.comment_id,
                  comment: jsonAnswer.data.comment,
                  createdAt: jsonAnswer.data.created_at,
                  firstname: user.firstname,
                  lastname: user.lastname,
                  qualification_relance: choiceRelance,
                  recall_date: choiceQualificationRecall,
                });
                setChoiceQualificationRecall(null);
                setChoiceRelance(null);
                setDisplayDateRecall(false);
                setIsTreated(true);
              } catch (err) {
                console.error(err);
                toast.error('Il y a eu un souci lors de l\'enregistrement !');
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
              }
            }}
          >
            {({ errors, handleSubmit, handleBlur, handleChange, setFieldValue, touched, values }) => (
              <form onSubmit={handleSubmit}>
                <CardHeader title="Laisser un commentaire" sx={{ px: 3, py: 2 }} />
                <Divider />
                <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        options={qualificationLabel}
                        onChange={(e, value) => {
                          handleChangeQualification(value);
                          setFieldValue('choiceRelance', value);
                        }}
                        value={values.choiceRelance}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Qualification"
                            name="choiceRelance"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              sx: { borderRadius: '12px' }
                            }}
                          />
                        )}
                      />
                    </Grid>
                    {displayDateRecall && (
                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(touched.choiceQualificationRecall && errors.choiceQualificationRecall)}
                          fullWidth
                          helperText={touched.choiceQualificationRecall && errors.choiceQualificationRecall}
                          label="Date et heure du rappel"
                          name="choiceQualificationRecall"
                          onBlur={handleBlur}
                          onChange={(event) => {
                            handleChange(event);
                            setChoiceQualificationRecall(event.target.value);
                          }}
                          type="datetime-local"
                          value={values.choiceQualificationRecall || ''}
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{ sx: { borderRadius: '12px' } }}
                        />
                      </Grid>
                    )}
                  </Grid>
                  
                  <TextField
                    label="Commentaire"
                    error={Boolean(touched.commentRelance && errors.commentRelance)}
                    fullWidth
                    helperText={touched.commentRelance && errors.commentRelance}
                    multiline
                    name="commentRelance"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.commentRelance || ''}
                    rows={3}
                    InputProps={{ sx: { borderRadius: '12px' } }}
                  />
                  
                  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-start' }}>
                    <Button
                      color="primary"
                      startIcon={<SaveIcon fontSize="small" />}
                      variant="contained"
                      disabled={isFormFilled}
                      onClick={() => {
                        handleSubmit();
                        saveTime();
                      }}
                      sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 700, px: 2.5 }}
                    >
                      Enregistrer
                    </Button>
                    <Button
                      color="error"
                      startIcon={<CancelIcon fontSize="small" />}
                      variant="outlined"
                      onClick={() => setCommenting(false)}
                      sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 700, px: 2.5 }}
                    >
                      Annuler
                    </Button>
                  </Box>
                </CardContent>
              </form>
            )}
          </Formik>
        </Card>
      )}

      <Card
        sx={{
          borderRadius: '24px',
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          backdropFilter: 'blur(20px)',
          boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
          overflow: 'hidden',
          minHeight: 195
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 3, py: 0.5 }}>
          <CardHeader title="Dernier commentaire" sx={{ px: 3, py: 2 }} />
          {!commenting && (
            <Button
              color="primary"
              startIcon={<PencilAltIcon fontSize="small" />}
              variant="contained"
              onClick={() => setCommenting(true)}
              sx={{ 
                borderRadius: '12px', 
                textTransform: 'none', 
                fontWeight: 700,
                px: 2.5,
                background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                boxShadow: (theme) => `0 4px 12px ${alpha(theme.palette.secondary.main, 0.2)}`
              }}
            >
              Qualifier l&apos;appel
            </Button>
          )}
        </Box>
        <Divider />
        {can('customers.comment_relance', user.access_level === 0 || user.id_service === 4) && (
          <CardContent sx={{ p: 3 }}>
            {comment_relance && commentRelance && Object.keys(commentRelance).length > 0 ? (
              <Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 2.5,
                    p: 3,
                    borderRadius: '20px',
                    backgroundColor: theme.palette.mode === 'light' ? grey(50) : greyAlpha(900, 0.25),
                    border: '1px solid',
                    borderLeft: `5px solid ${getQualificationColor(commentRelance.qualification_relance)}`,
                    borderColor: 'divider',
                    boxShadow: (theme) => `0 4px 12px ${alpha(theme.palette.common.black, 0.01)}`
                  }}
                  {...other}
                >
                  <Avatar
                    sx={{
                      backgroundColor: getQualificationColor(commentRelance.qualification_relance),
                      color: grey(0),
                      width: 40,
                      height: 40,
                      boxShadow: (theme) => `0 2px 8px ${alpha(theme.palette.common.black, 0.08)}`
                    }}
                  >
                    {commentRelance.qualification_relance === 'Suivi - Mail' && <MailOutlineIcon />}
                    {commentRelance.qualification_relance === 'Suivi - SMS' && <SmsIcon />}
                    {commentRelance.qualification_relance === 'Suivi - Téléphone' && <PhoneAndroidIcon />}
                    {commentRelance.qualification_relance === 'Décalage' && <CalendarTodayIcon />}
                    {commentRelance.qualification_relance === 'À rappeler' && <PhoneIcon />}
                    {commentRelance.qualification_relance === 'Souhaite un email' && <MailOutlineIcon />}
                    {commentRelance.qualification_relance === 'Annulation' && <HighlightOffIcon />}
                    {commentRelance.qualification_relance === 'Va se connecter' && <HourglassEmptyIcon />}
                    {commentRelance.qualification_relance === 'Numéro incorrect' && <PhoneDisabledIcon />}
                    {commentRelance.qualification_relance === 'Pas répondu' && <PhoneMissedIcon />}
                  </Avatar>
                  
                  <Box sx={{ flexGrow: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.primary' }}>
                        {`${commentRelance.firstname} ${commentRelance.lastname}`}
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                        {new Date(commentRelance.createdAt).toLocaleDateString('fr-FR', options)}
                      </Typography>
                    </Box>
                    
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        px: 1.5,
                        py: 0.5,
                        borderRadius: '12px',
                        fontSize: '0.75rem',
                        fontWeight: 700,
                        backgroundColor: 'action.hover',
                        color: getQualificationColor(commentRelance.qualification_relance),
                        mb: 1.5
                      }}
                    >
                      {`${commentRelance.qualification_relance} ${commentRelance.recall_date === undefined || commentRelance.recall_date === null || commentRelance.recall_date === '' ? '' : `• Rappel prévu le ${moment(commentRelance.recall_date).format('DD/MM/YYYY à H:mm')}`}`}
                    </Box>

                    <Typography variant="body2" sx={{ color: 'text.secondary', whiteSpace: 'pre-wrap', lineHeight: 1.6, fontWeight: 500 }}>
                      {commentRelance.comment || 'Aucun commentaire textuel rédigé.'}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Typography sx={{ color: 'text.secondary', fontStyle: 'italic', textAlign: 'center', py: 4 }}>
                Aucun commentaire de relance enregistré pour cet apprenant.
              </Typography>
            )}
          </CardContent>
        )}
      </Card>
    </Box>
  );
};

RelaunchCustomerRelaunchComment.propTypes = {
  comment_relance: PropTypes.object,
  customer: PropTypes.object,
  formations: PropTypes.array,
  customerId: PropTypes.string,
  campaignId: PropTypes.string,
  setIsTreated: PropTypes.func,
  saveTime: PropTypes.func,
  commentRelance: PropTypes.object,
  setCommentRelance: PropTypes.func
};

export default RelaunchCustomerRelaunchComment;
